export const ASSISTANT_VARIABLE_SAMPLE_MAX_CHARACTERS = 120;
